import React, { Component } from 'react'
import PropTypes from 'prop-types'

// import InputRange from 'react-input-range'

import Beds from './Beds'
import Bedrooms from './Bedrooms'
import Budget from './Budget'
import Type from './Type'
import Amenities from './Amenities'

export default class AllFilters extends Component {
  static propTypes = {
    applyFilter: PropTypes.func.isRequired,
    minBeds: PropTypes.number.isRequired,
    maxBeds: PropTypes.number.isRequired,
    minBedrooms: PropTypes.number.isRequired,
    maxBedrooms: PropTypes.number.isRequired,
    minBudget: PropTypes.number.isRequired,
    maxBudget: PropTypes.number.isRequired,
    types: PropTypes.arrayOf(PropTypes.string).isRequired,
    amenities: PropTypes.arrayOf(PropTypes.string).isRequired,
    typeCounts: PropTypes.shape({
      apartment: PropTypes.number,
      hotel: PropTypes.number,
      villa: PropTypes.number,
    }).isRequired,
    amenityCounts: PropTypes.objectOf(PropTypes.number).isRequired,
    amenityDefinition: PropTypes.objectOf(PropTypes.string).isRequired,
  }

  state = {
    minBeds: null,
    maxBeds: null,
    minBedrooms: null,
    maxBedrooms: null,
    minBudget: null,
    maxBudget: null,
    types: [],
    amenities: [],
  }

  constructor (props) {
    super(props)

    this.state = {
      minBeds: props.minBeds,
      maxBeds: props.maxBeds,
      minBedrooms: props.minBedrooms,
      maxBedrooms: props.maxBedrooms,
      minBudget: props.minBudget,
      maxBudget: props.maxBudget,
      types: props.types,
      amenities: props.amenities,
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      minBeds: nextProps.minBeds,
      maxBeds: nextProps.maxBeds,
      minBedrooms: nextProps.minBedrooms,
      maxBedrooms: nextProps.maxBedrooms,
      minBudget: nextProps.minBudget,
      maxBudget: nextProps.maxBudget,
      types: nextProps.types,
      amenities: nextProps.amenities,
    })
  }

  applyFilter = () => {
    this.props.applyFilter(this.state)
  }

  storeBedsValue = (min, max) => this.setState({ minBeds: min, maxBeds: max })
  storeBedroomsValue = (min, max) => this.setState({ minBedrooms: min, maxBedrooms: max })
  storeBudgetValue = (min, max) => this.setState({ minBudget: min, maxBudget: max })

  toggleType = (value) => {
    this.setState((state) => ({
      types: state.types.includes(value)
        ? state.types.filter((item) => item !== value)
        : [ ...state.types, value ],
    }))
  }

  toggleAmenity = (value) => {
    this.setState((state) => ({
      amenities: state.amenities.includes(value)
        ? state.amenities.filter((item) => item !== value)
        : [ ...state.amenities, value ],
    }))
  }

  render () {
    const { typeCounts, amenityCounts, amenityDefinition } = this.props

    const {
      minBeds,
      maxBeds,
      minBedrooms,
      maxBedrooms,
      minBudget,
      maxBudget,
      types,
      amenities,
    } = this.state

    return (
      <>
        <div className='filter-sliders'>
          <Beds minBeds={minBeds} maxBeds={maxBeds} onChange={this.storeBedsValue} />
          <Bedrooms minBedrooms={minBedrooms} maxBedrooms={maxBedrooms} onChange={this.storeBedroomsValue} />
          <Budget minBudget={minBudget} maxBudget={maxBudget} onChange={this.storeBudgetValue} />
        </div>

        <Type types={types} onChange={this.toggleType} typeCounts={typeCounts} />
        <Amenities amenities={amenities} onChange={this.toggleAmenity} amenityCounts={amenityCounts} amenityDefinition={amenityDefinition} />

        <button type='button' className='btn btn--primary filter-button' onClick={this.applyFilter}>Apply filters</button>
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/filters/AllFilters.js